import axios from 'axios';

// Set up axios instance with auth token
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  withCredentials: true,
});


// Get all hotels (public)
export const getAllHotels = async (queryParams = {}) => {
    try {
        const queryString = new URLSearchParams(queryParams).toString();
        const response = await api.get(`/hotel?${queryString}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch hotels');
    }
};

// Get hotel details (public)
export const getHotelDetails = async (id) => {
    try {
        const response = await api.get(`/hotel/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch hotel details');
    }
};

export const deleteHotelBooking = async(roomId, bookingId) => {
  try {
    const response = await api.delete(`hotel/rooms/${roomId}/bookings/${bookingId}`);
    return (await response).data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch hotel details');
  }
}

export const getHotelBookings = async() => {
  try {
    const response = await api.get('/hotel/bookings');
    return {
      success: true,
      data: response.data.bookings,
      hotel: response.data.hotel
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch hotel details');
  }
}


export const cancelBookingByHotel = async (roomId, bookingId, reason = '') => {
  try {
    const response = await api.put(
      `/hotel/rooms/${roomId}/bookings/${bookingId}/cancel-by-hotel`,
      { reason }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to cancel booking');
  }
};






export const logoutHotel = async () => {
  try {
    const response = await api.post('/hotel/logout');
    return {
      success: response.data.success,
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to logout');
  }
}
